export default {
  // Der Filter über der Tabelle eines Katalogs: Einträge und Pakete zusammen oder eines von beiden. Die
  // Einträge heißen wie der Katalog („Materialien“), aus nav.*.overview.
  kind_filter: {
    label: "Anzeigen",
    all: "Alle",
    packets: "Pakete",
  },
  overview: {
    // Die Liste aller Pakete (PacketOverview), nur über die Befehlspalette erreichbar.
    title: "Pakete",
    subtitle: "Alle Pakete aus Materialien, Maschinen und Zusatzleistungen an einem Ort.",
    search: {
      placeholder: "bspw. Name",
    },
    // Die Unterzeile für jemanden, der nur die Pakete eines Katalogs lesen darf, nicht den Katalog selbst.
    subtitle_material: "Pakete bündeln mehrere Materialien, die ein Projekt oder ein Kunde in einem Schritt übernimmt.",
    subtitle_machine: "Pakete bündeln mehrere Maschinen, die ein Projekt oder ein Kunde in einem Schritt übernimmt.",
    subtitle_additional_effort:
      "Pakete bündeln mehrere Zusatzleistungen, die ein Projekt oder ein Kunde in einem Schritt übernimmt.",
    actions: {
      create_new: "Neues Paket erstellen",
    },
    // Unter dem Namen einer Paketzeile in der Tabelle eines Katalogs.
    row_caption: "Paket · {count} Position | Paket · {count} Positionen",
    // Unter dem Namen einer Zeile in der Liste aller Pakete: die Paketart.
    kind: {
      MATERIAL: "Materialpaket",
      MACHINE: "Maschinenpaket",
      ADDITIONAL_EFFORT: "Zusatzleistungspaket",
    },
    table: {
      headers: {
        name: "Name",
        catalog: "Katalog",
        amount: "Anzahl",
      },
    },
  },
  detail: {
    title: "Paket Details",
    tabs: {
      general: "Stammdaten",
      activity: "Protokoll",
    },
    actions: {
      delete: {
        modal: {
          title: "Paket Löschen",
          text: "Bist du sicher, dass du dieses Paket löschen willst?",
        },
        delete: "Löschen",
      },
      update: "Speichern",
    },
    form: {
      name: "Name",
      // Steht anstelle der Liste, solange das Paket leer ist. Ohne Position lässt es sich nicht
      // speichern, also sagt der Platzhalter, was zu tun ist.
      items_empty: "Noch keine Positionen. Such oben nach einem Eintrag, um ihn ins Paket zu legen.",
      // Neben items_empty, sobald Speichern gedrückt wurde: dann fehlt die Position wirklich.
      items_required: "Ein Paket braucht mindestens eine Position.",
      // Spaltenköpfe der Positionstabelle. Einheit und Einkaufspreis stehen, sobald eine Position sie
      // mitbringt (FrontendPacketTypeReferenceResponse) — bei allen drei Paketarten.
      table: {
        entry: "Eintrag",
        unit: "Abrechnungseinheit",
        purchase_price: "Einkaufspreis",
        no_price: "Nicht gesetzt",
      },
      additional_effort: {
        add: "Zusatzleistung hinzufügen",
        subheader: "Zusätzliche Aufwände",
      },
      machine: {
        add: "Maschine hinzufügen",
        subheader: "Maschinen",
      },
      material: {
        add: "Material hinzufügen",
        subheader: "Materialien",
      },
    },
  },
  create: {
    additional_effort: {
      title: "Paket Anlegen",
      subtitle: "Neues Paket mit Zusätzlichen Aufwänden anlegen.",
    },
    machine: {
      title: "Paket Anlegen",
      subtitle: "Neues Paket mit Maschinen anlegen.",
    },
    material: {
      title: "Paket Anlegen",
      subtitle: "Neues Paket mit Materialien anlegen.",
    },
  },
}
